export default "__VITE_ASSET__DzrvSE5q__"